export default {
  name: 'master-consumable-item-input',
  props: {
    consumableItemParent: {
      type: Object,
      required: true,
      default: () => ({})
    },
    categoriesParent: {
      type: Array,
      required: false,
      default: () => []
    },
    suppliersParent: {
      type: Array,
      required: false,
      default: () => []
    },
    isStockCheckPeriod: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  created () {
    this.consumableItem = this.consumableItemParent
    this.categories = this.categoriesParent
    this.suppliers = this.suppliersParent
    this.isShow = true
  },
  data () {
    return {
      consumableItem: {},
      categories: [],
      suppliers: [],
      isShow: false
    }
  },
  computed: {
    validation () {
      let hiragana = /^[\u3040-\u309fー]+$/

      const validation = {
        name: !!this.consumableItem.name,
        name_hurigana: !!this.consumableItem.name_hurigana && hiragana.test(this.consumableItem.name_hurigana),
        product_code: !!this.consumableItem.product_code,
        category_id: !!this.consumableItem.category_id,
        supplier_id: !!this.consumableItem.supplier_id,
        lot_price: !!this.consumableItem.lot_price,
        unit: !!this.consumableItem.unit,
        lot_number: !!this.consumableItem.lot_number
      }
      return validation
    },
    validationAll () {
      if (!this.validation.name) return false
      if (!this.validation.name_hurigana) return false
      if (!this.validation.product_code) return false
      if (!this.validation.category_id) return false
      if (!this.validation.supplier_id) return false
      if (!this.validation.lot_price) return false
      if (!this.validation.unit) return false
      if (!this.validation.lot_number) return false
      return true
    }
  },
  methods: {
    async sendData () {
      const formData = new FormData()
      formData.append('id', this.$route.params.consumable_item_id)
      formData.append('name', this.consumableItem.name)
      formData.append('name_hurigana', this.consumableItem.name_hurigana)
      formData.append('product_code', this.consumableItem.product_code)
      formData.append('category_id', this.consumableItem.category_id)
      formData.append('supplier_id', this.consumableItem.supplier_id)
      formData.append('lot_price', this.consumableItem.lot_price)
      formData.append('unit', this.consumableItem.unit)
      formData.append('size', this.consumableItem.size)
      formData.append('lot_number', this.consumableItem.lot_number)
      formData.append('is_can_order', this.consumableItem.is_can_order)
      formData.append('remark', this.consumableItem.remark)
      this.$emit('sendData', formData)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/master-consumable-item-input.js